<template>
  <div id="app">
    <Todo_timer :todos="todos" class="pr-3 pl-3"/>
    <Todos
      :todos="todos"
      @del_all_tasks="del_all_tasks"
      @del-task-app="delTask"
      @add_tolist="add_tolist_met"
      @select_id="select_id"
      />
  </div>
</template>

<script>
import Todos from './components/Todotasks/Todos';
import Todo_timer from './components/Todotimer/Todo_timer';

export default {
  name: 'App',
  components: {
    Todos,
    Todo_timer,
  },
  data(){
    return {
      todos: [],
      select_id:""
    }
  },
   methods: {
     del_all_tasks() {
       this.todos = [];

     },
     delTask(id){
       this.todos = this.todos.filter(todo => todo.id !== id);
     },
     add_tolist_met(new_item){
       this.todos.push(new_item);
     },
     select_task(task){
       this.select_id = task;
     }
  },
  mounted(){
        window.addEventListener('beforeunload', (event) => {
          event.preventDefault();
          event.returnValue = '';
          for(var i in this.todos){
            if(this.todos[i].completed){
              this.todos.splice(this.todos.indexOf(this.todos[i]), 1);
            }

          }
          localStorage.setItem('todo_items', JSON.stringify(this.todos));

        });
      // console.log('App Mounted');
      if (localStorage.getItem('todo_items'))
        this.todos = JSON.parse(localStorage.getItem('todo_items'));
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
   display: flex;
}

.todo-item{
  background: #f4f4f4f4;
  border-bottom: 4px #ccc dotted;
}
</style>
